import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  image: string;
}

function SEO({ title, image }: SEOProps) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta
        name="description"
        content="낚시대/릴 온라인 최저가 보상하는 낚시 전문 쇼핑몰 어바웃피싱. 신규 가입 시 3만 적립금 즉시 지급!"
      />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="260" />
      <meta property="og:image:height" content="260" />
      <meta
        property="og:description"
        content="낚시대/릴 온라인 최저가 보상하는 낚시 전문 쇼핑몰 어바웃피싱. 신규 가입 시 3만 적립금 즉시 지급!"
      />
      <meta property="og:locale" content="ko_KR" />
    </Helmet>
  );
}

export default SEO;
